import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { ApiError } from "@finora/api-client";
import { Button } from "@finora/ui";
import { api } from "../../lib/api";

/**
 * "Nalog" tab (Podešavanja) - samostalna promena lozinke ulogovanog
 * korisnika (30.09.2026). Vidi POST /auth/change-password.
 */
export function AccountTab() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mismatchError, setMismatchError] = useState(false);

  const changePassword = useMutation({
    mutationFn: () => api.changePassword({ currentPassword, newPassword }),
    onSuccess: () => {
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    },
  });

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMismatchError(true);
      return;
    }
    setMismatchError(false);
    changePassword.mutate();
  }

  return (
    <div className="max-w-md rounded-xl border border-border bg-surface p-5 shadow-subtle">
      <h2 className="mb-1 text-sm font-semibold text-slate-800">Promena lozinke</h2>
      <p className="mb-4 text-xs text-slate-400">
        Za promenu lozinke potrebno je da unesete trenutnu lozinku.
      </p>
      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="mb-1 block text-sm font-medium text-slate-700">Trenutna lozinka</label>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            className="h-10 w-full rounded-lg border border-border px-3 text-sm focus:border-brand focus:outline-none"
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-slate-700">Nova lozinka</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={6}
            className="h-10 w-full rounded-lg border border-border px-3 text-sm focus:border-brand focus:outline-none"
          />
          <p className="mt-1 text-xs text-slate-400">Najmanje 6 karaktera.</p>
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-slate-700">Potvrda nove lozinke</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={6}
            className="h-10 w-full rounded-lg border border-border px-3 text-sm focus:border-brand focus:outline-none"
          />
        </div>

        {mismatchError && (
          <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">
            Nova lozinka i potvrda se ne poklapaju.
          </p>
        )}
        {changePassword.isError && (
          <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">
            {changePassword.error instanceof ApiError
              ? changePassword.error.response.message
              : "Promena lozinke nije uspela."}
          </p>
        )}
        {changePassword.isSuccess && !changePassword.isPending && (
          <p className="rounded-lg bg-emerald-50 px-3 py-2 text-sm text-emerald-700">
            Lozinka je uspešno promenjena.
          </p>
        )}

        <div className="flex justify-end pt-1">
          <Button type="submit" disabled={changePassword.isPending}>
            {changePassword.isPending ? "Čuvam..." : "Sačuvaj"}
          </Button>
        </div>
      </form>
    </div>
  );
}
